function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m416.4 247.4v-180m-385 190h376",
  stroke: "#145569",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "m21.4 67.4v180",
  stroke: "#145569"
}), React.createElement("path", {
  d: "m407.4 57.4h-374.2",
  stroke: "#135063",
  strokeLinecap: "round"
}), React.createElement("g", {
  stroke: "#46c3d7"
}, React.createElement("path", {
  d: "m153.5 51.5h133v12h-133z",
  fill: "#135063"
}), React.createElement("path", {
  d: "m158.5 57.5h122",
  strokeDasharray: "3 3"
})), React.createElement("path", {
  d: "m327 89v22h38v-22z",
  fill: "#46c3d7",
  stroke: "#fff"
}), React.createElement("path", {
  d: "m339 101h-4v4h-2v-10h6.4v1.7h-4.4v2.6h4v1.6zm3 4h-2v-7.4h2zm-2-9.3c0-.3 0-.6.2-.7.2-.2.5-.3.9-.3.3 0 .6 0 .8.3.2.1.3.4.3.7s-.1.5-.3.7-.5.3-.8.3c-.4 0-.6 0-.9-.3a1 1 0 0 1 -.3-.7zm5 1.9v.9c.6-.7 1.3-1 2.2-1 .8 0 1.3.2 1.7.7.4.4.6 1.1.6 2v4.8h-2v-4.7c0-.4 0-.8-.2-1l-1-.2c-.5 0-1 .2-1.2.7v5.2h-2v-7.4zm9.8 7.4-.2-.7c-.5.6-1.1.8-1.9.8-.7 0-1.3-.2-1.8-.6a2 2 0 0 1 -.7-1.6c0-.8.3-1.4.9-1.8s1.4-.6 2.5-.6h1v-.4c0-.4-.2-.7-.3-.9-.2-.2-.5-.3-.9-.3-.3 0-.6.1-.8.3l-.2.6h-2c0-.4.1-.8.4-1.2.2-.3.6-.6 1.1-.8a4 4 0 0 1 1.6-.3c1 0 1.7.2 2.2.7.5.4.8 1 .8 1.9v3.2c0 .7.1 1.2.3 1.6v.1zm-1.6-1.4c.3 0 .5 0 .8-.2l.5-.5v-1.3h-.7c-1 0-1.5.4-1.6 1v.2c0 .2 0 .4.3.6zm6.4 1.4h-2v-10.5h2z",
  fill: "#071920",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "m346 57v31.5",
  stroke: "#fff",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "m347.5 57a1.5 1.5 0 1 0 -3 0 1.5 1.5 0 0 0 3 0",
  fill: "#fff"
}), React.createElement("g", {
  stroke: "#fff"
}, React.createElement("path", {
  d: "m349 57a3 3 0 1 0 -6 0 3 3 0 0 0 6 0",
  opacity: 0.5
}), React.createElement("path", {
  d: "m351 57a5 5 0 1 0 -10 0 5 5 0 0 0 10 0",
  opacity: 0.25
}), React.createElement("path", {
  d: "m384 168v-22h-41v22z",
  fill: "#46c3d7"
})), React.createElement("path", {
  d: "m349.8 162v-10h3.5c1.2 0 2.1.3 2.7.7.6.5 1 1.2 1 2 0 .6-.2 1-.4 1.4l-1 .8a2.3 2.3 0 0 1 1.6 2.2c0 1-.3 1.7-1 2.1-.5.5-1.4.8-2.5.8h-4zm2-4.3v2.7h1.8c.5 0 .9-.2 1.1-.4.3-.2.4-.5.4-1 0-.9-.4-1.3-1.4-1.3zm0-1.5h1.6c1 0 1.5-.4 1.5-1.2 0-.5-.1-.8-.4-1-.2-.2-.7-.3-1.2-.3h-1.5zm10.6 5.8-.2-.7c-.5.6-1.1.8-1.9.8-.7 0-1.3-.2-1.8-.6a2 2 0 0 1 -.7-1.6c0-.8.3-1.4.9-1.8.5-.4 1.4-.6 2.5-.6h.9v-.4c0-.4 0-.7-.3-.9-.1-.2-.4-.3-.8-.3-.3 0-.6.1-.8.3-.2.1-.3.3-.3.6h-2c0-.4.2-.8.5-1.2.2-.3.6-.6 1-.8a4 4 0 0 1 1.7-.3c1 0 1.6.2 2.2.7.5.4.8 1 .8 1.9v3.2c0 .7 0 1.2.3 1.6v.1zm-1.7-1.4c.3 0 .6 0 .8-.2.3-.1.5-.3.6-.5v-1.3h-.7c-1 0-1.6.4-1.6 1v.2c0 .2 0 .4.2.6zm8.4-.6c0-.3-.1-.5-.4-.6a4 4 0 0 0 -1.1-.4c-1.8-.4-2.6-1.1-2.6-2.2 0-.7.2-1.2.8-1.7.5-.4 1.2-.6 2.1-.6 1 0 1.7.2 2.3.6.5.5.8 1 .8 1.8h-2c0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3-.3 0-.6 0-.8.2s-.2.3-.2.6c0 .2 0 .4.3.5l1 .4c.5 0 1 .2 1.3.3 1 .4 1.5 1 1.5 2a2 2 0 0 1 -.8 1.6c-.6.4-1.4.6-2.3.6a4 4 0 0 1 -1.6-.3c-.5-.2-.9-.5-1.2-.9-.2-.4-.4-.8-.4-1.3h1.9c0 .4.1.7.4.9l1 .2c.3 0 .6 0 .8-.2.2-.1.3-.3.3-.5zm6.1 2.1c-1 0-2-.3-2.7-1-.6-.6-1-1.5-1-2.6v-.2c0-.8.2-1.4.5-2 .2-.6.7-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .6.6.8 1.5.8 2.6v.8h-4.7c0 .5.3 1 .6 1.2.3.3.7.4 1.2.4.8 0 1.4-.2 1.8-.8l1 1.1a3 3 0 0 1 -1.2 1 4 4 0 0 1 -1.7.3zm-.2-6c-.4 0-.7.1-1 .4a2 2 0 0 0 -.4 1.1h2.7v-.2c0-.4-.1-.7-.4-1-.2-.2-.5-.3-1-.3z",
  fill: "#071920",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "m416 157.5h-31.5",
  stroke: "#fff",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "m416 159a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  fill: "#fff"
}), React.createElement("path", {
  d: "m416 160.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
  opacity: 0.5,
  stroke: "#fff"
}), React.createElement("path", {
  d: "m416 162.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
  opacity: 0.25,
  stroke: "#fff"
}), React.createElement("path", {
  d: "m256 226v-22h-73v22z",
  fill: "#46c3d7",
  stroke: "#fff"
}), React.createElement("path", {
  d: "m190 220v-10h3c.9 0 1.7.2 2.4.6s1.2 1 1.6 1.7.6 1.6.6 2.5v.5c0 .9-.2 1.7-.6 2.4a4 4 0 0 1 -1.6 1.7c-.7.4-1.5.6-2.4.6zm2-8.3v6.7h1c.8 0 1.4-.3 1.8-.8.5-.6.7-1.3.7-2.3v-.5c0-1-.2-1.8-.6-2.3-.5-.5-1-.8-1.9-.8zm6.1 4.5c0-.7.2-1.4.4-2a3.6 3.6 0 0 1 3-1.8c1.1 0 2 .4 2.6 1s1 1.4 1 2.5v.5c0 1.1-.3 2-1 2.7-.6.7-1.4 1-2.5 1-1 0-1.9-.3-2.5-1a4 4 0 0 1 -1-2.8zm2 .2c0 .7.1 1.2.4 1.6.2.4.6.5 1.1.5s.9-.1 1.1-.5c.3-.4.4-1 .4-1.8 0-.7 0-1.2-.4-1.6-.2-.3-.6-.5-1-.5-.6 0-1 .2-1.2.5a3 3 0 0 0 -.4 1.8zm12.2 1 1-4.8h1.8l-1.8 7.4h-1.7l-1.4-4.7-1.4 4.7h-1.6l-2-7.4h2l1 4.7 1.3-4.7h1.4l1.4 4.7zm5.1-4.8.1.9c.5-.7 1.2-1 2.1-1 .8 0 1.4.2 1.8.7.4.4.6 1.1.6 2v4.8h-2v-4.7c0-.4-.1-.8-.3-1l-.9-.2c-.5 0-1 .2-1.2.7v5.2h-2v-7.4zm12 4.7 1-4.7h1.9l-2 7.4h-1.6l-1.4-4.7-1.4 4.7h-1.6l-1.9-7.4h2l.9 4.7 1.3-4.7h1.5zm5.4 2.7h-2v-7.4h2zm-2-9.3c0-.3 0-.6.2-.7.2-.2.5-.3.8-.3.4 0 .7 0 .9.3.2.1.3.4.3.7s-.1.5-.3.7c-.3.2-.5.3-.9.3-.3 0-.6 0-.8-.3a1 1 0 0 1 -.3-.7zm5 1.9v.9c.6-.7 1.3-1 2.2-1 .8 0 1.3.2 1.7.7.4.4.6 1.1.6 2v4.8h-2v-4.7c0-.4 0-.8-.2-1l-1-.2c-.5 0-1 .2-1.2.7v5.2h-2v-7.4zm5.2 3.6c0-1.1.3-2 .8-2.7s1.2-1 2.1-1c.7 0 1.3.2 1.8.8v-3.8h2v10.5h-1.8l-.1-.8c-.5.6-1.1 1-2 1-.8 0-1.5-.4-2-1-.5-.8-.8-1.7-.8-3zm2 .2c0 .7.1 1.2.3 1.6.3.4.6.5 1 .5.7 0 1.1-.2 1.4-.7v-3c-.3-.5-.7-.7-1.3-.7-1 0-1.4.7-1.4 2.3z",
  fill: "#071920",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "m219 258v-31.5",
  stroke: "#fff",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "m217.5 258a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0 -3 0",
  fill: "#fff"
}), React.createElement("path", {
  d: "m216 258a3 3 0 1 0 6 0 3 3 0 0 0 -6 0",
  opacity: 0.5,
  stroke: "#fff"
}), React.createElement("path", {
  d: "m214 258a5 5 0 1 0 10 0 5 5 0 0 0 -10 0",
  opacity: 0.25,
  stroke: "#fff"
}), React.createElement("path", {
  d: "m126 168v-22h-73v22z",
  fill: "#46c3d7",
  stroke: "#fff"
}), React.createElement("path", {
  d: "m67.4 158.7c0 1-.5 1.9-1.2 2.5s-1.6 1-2.8 1c-1.3 0-2.3-.5-3-1.4-.7-.8-1-2-1-3.5v-.6c0-1 0-1.8.4-2.5a3.8 3.8 0 0 1 3.6-2.3 4 4 0 0 1 2.8 1c.7.5 1.1 1.4 1.2 2.5h-2c0-.6-.2-1-.6-1.4-.3-.3-.7-.4-1.4-.4-.6 0-1.2.2-1.5.7s-.5 1.3-.5 2.3v.8c0 1 .1 1.8.5 2.3.3.5.8.8 1.5.8.6 0 1.1-.2 1.4-.5s.5-.7.6-1.3zm4.9-2.2-.7-.1c-.8 0-1.3.3-1.5.8v4.8h-2v-7.4h1.9v.9c.5-.7 1-1 1.7-1h.6zm-.1 1.7c0-.7.1-1.4.4-2 .3-.5.7-1 1.2-1.3.6-.3 1.2-.4 1.9-.4 1 0 1.8.3 2.4.9.7.6 1 1.4 1 2.5l.1.5c0 1.1-.3 2-1 2.7-.6.7-1.4 1-2.5 1-1 0-2-.3-2.6-1a4 4 0 0 1 -1-2.8zm2 .2c0 .7.1 1.2.4 1.6.2.4.6.5 1.1.5s.8-.1 1.1-.5.4-1 .4-1.8c0-.7-.1-1.2-.4-1.6-.3-.3-.6-.5-1.1-.5s-.9.2-1.1.5a3 3 0 0 0 -.4 1.8zm9.7 1.6c0-.3-.1-.5-.3-.6a4 4 0 0 0 -1.2-.4c-1.7-.4-2.6-1.1-2.6-2.2 0-.7.2-1.2.8-1.7.5-.4 1.2-.6 2.1-.6 1 0 1.7.2 2.3.6.5.5.8 1 .8 1.8h-2c0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3-.3 0-.6 0-.8.2l-.2.6c0 .2 0 .4.3.5l1 .4c.5 0 1 .2 1.3.3 1 .4 1.5 1 1.5 2a2 2 0 0 1 -.8 1.6c-.6.4-1.4.6-2.3.6a4 4 0 0 1 -1.6-.3c-.5-.2-.9-.5-1.2-.9-.2-.4-.4-.8-.4-1.3h2c0 .4 0 .7.3.9l1 .2c.3 0 .6 0 .8-.2.2-.1.3-.3.3-.5zm6.7 0c0-.3-.1-.5-.3-.6a4 4 0 0 0 -1.2-.4c-1.8-.4-2.6-1.1-2.6-2.2 0-.7.2-1.2.8-1.7.5-.4 1.2-.6 2.1-.6 1 0 1.7.2 2.3.6.5.5.8 1 .8 1.8h-2c0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3-.3 0-.6 0-.8.2l-.2.6c0 .2 0 .4.3.5l1 .4c.5 0 1 .2 1.3.3 1 .4 1.5 1 1.5 2a2 2 0 0 1 -.8 1.6c-.6.4-1.4.6-2.3.6a4 4 0 0 1 -1.6-.3c-.5-.2-.9-.5-1.2-.9-.2-.4-.4-.8-.4-1.3h2c0 .4 0 .7.3.9l1 .2c.3 0 .6 0 .8-.2.2-.1.3-.3.3-.5zm9.1-.7 1-4.7h2l-2 7.4h-1.6l-1.4-4.7-1.4 4.7h-1.7l-1.9-7.4h2l1 4.7 1.3-4.7h1.4zm5.5 2.7h-2v-7.4h2zm-2.1-9.3c0-.3 0-.6.3-.7.2-.2.5-.3.8-.3s.6 0 .8.3c.2.1.3.4.3.7s-.1.5-.3.7-.5.3-.8.3-.6 0-.8-.3a1 1 0 0 1 -.3-.7zm5 1.9v.9c.6-.7 1.3-1 2.2-1 .8 0 1.4.2 1.8.7.3.4.5 1.1.6 2v4.8h-2v-4.7c0-.4-.1-.8-.3-1l-.9-.2c-.6 0-1 .2-1.3.7v5.2h-2v-7.4h2zm5.2 3.6c0-1.1.3-2 .8-2.7s1.2-1 2.1-1c.8 0 1.4.2 1.8.8v-3.8h2v10.5h-1.8v-.8c-.6.6-1.2 1-2 1s-1.5-.4-2-1c-.6-.8-.9-1.7-.9-3zm2 .2c0 .7.1 1.2.4 1.6.2.4.6.5 1 .5.6 0 1-.2 1.3-.7v-3c-.2-.5-.6-.7-1.3-.7-.9 0-1.4.7-1.4 2.3z",
  fill: "#071920",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "m22 157h31.5",
  stroke: "#fff",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "m22 155.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
  fill: "#fff"
}), React.createElement("path", {
  d: "m22 154a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
  opacity: 0.5,
  stroke: "#fff"
}), React.createElement("path", {
  d: "m22 152a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
  opacity: 0.25,
  stroke: "#fff"
}), React.createElement("path", {
  d: "m220 19.7h3m-3 4h3",
  stroke: "#145569",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "m220 40.2v-22.7",
  stroke: "#fff",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "m224 17.6a.9.9 0 0 0 -1 .9v6.4a.9.9 0 0 0 1 .9l3.4-.6v-7z",
  fill: "#e66e0a",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "m227.4 18.2v7l4.4-.6v-5.8z",
  fill: "#fff",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "m235.5 19.4-3.6-.6v5.8l3.6-.6c.4 0 .8-.4.8-.8v-3c0-.4-.4-.7-.8-.8z",
  fill: "#e66e0a",
  fillRule: "nonzero"
}));

var SvgTraffic = function SvgTraffic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 422 264",
    width: 422,
    height: 264,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTraffic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/traffic.3f92a168.svg";
export { ForwardRef as ReactComponent };